const constants = {
  stage: {
    before_call: 'Ждет звонка',
    after_call: 'Ждет вводного урока',
    after_trial: 'Был вводный урок',
    regular_lessons: 'Регулярные занятия',
    lost: 'Ученик потерян',
    vacation: 'Ученик в отпуске',
  },
  incorrectnessReason: {
    moved_to_crm1: 'Перенесена в CRM1',
    contact_details_incorrect: 'Контактные данные некорректны',
    other_people_contact_information: 'Чужие контактные данные',
    attempt_to_find_job: 'Попытка найти работу',
    kid_does_not_communicate: 'Ребенок не общается',
    customer_wanted_another_service: 'Клиент захотел другую услугу (Дубль)',
    tested_education_service: 'Тестовая услуга',
  },
  groupLessons: {
    contextId: {
      'too-hard': 'Ученику сложно',
      'too-easy': 'Ученику легко',
      'unsuitable-schedule': 'Требуется смена графика',
      'dislike-group': 'Не нравится группа',
      'dislike-teacher': 'Не нравится преподаватель',
      'study-with-friend': 'Хочет заниматься с другом',
      'long-start-waiting': 'Не набирается новая группа',
      'group-disband': 'Расформирование текущей группы',
      'early-vacation-leaving-CS': 'Досрочный выход из отпуска',
    },
  },
};

export default constants;
